import { MapState } from 'pigeon-maps'
import { MutableRefObject, ReactNode } from 'react'
import { MapScaleFunction } from '@/utils/svg'

const SVGOverlay = (props: {
  children: (scale: MapScaleFunction) => ReactNode
  latLngToPixel?: MapScaleFunction
  mapState?: MapState
  svgRef?: ((el: SVGSVGElement | null) => void) | MutableRefObject<SVGSVGElement>
}): JSX.Element => {
  if (props.latLngToPixel === undefined || props.mapState === undefined) {
    return <></>
  }

  return (
    <svg
      ref={props.svgRef}
      style={{ position: 'absolute', pointerEvents: 'none' }}
      width={props.mapState.width}
      height={props.mapState.height}
    >
      {props.children(props.latLngToPixel)}
    </svg>
  )
}

export default SVGOverlay
